<template>
    <div class="o-dashboard">

        <div class="o-dashboard__breadcrumbs" v-if="item.product">
            <ul class="c-breadcrumbs">
                <li>
                    <a :href="'/voorraad/' + item.product.id">{{ item.product.name }}</a>
                </li>
                <li>
                    <span>{{ item.serial }}</span>
                </li>
            </ul>
        </div>

        <div class="o-dashboard__panels" v-if="item.product">
            <div class="row collapse">

                <div class="column small-12 xlarge-8">

                    <c-block-item-info :item="item"></c-block-item-info>

                    <c-block-activities v-if="status"
                        :endpoint="'/api/items/' + this.$route.params.id"
                        :status="status"
                        :key="activitiesRender"
                    ></c-block-activities>
                </div>

                <div class="column small-12 xlarge-4" v-for="media in item.product.media" :key="media.id">

                    <c-block-image :url="media.original_url"></c-block-image>

                </div>

            </div>
        </div>

        <c-new-stock
            v-if="item.product"
            v-show="modal"
            @close="modal=false"
            @added="load"
            :size="'medium'"
            :edit="true"
            :item="item"
            :title="'Voorraad aanpassen'">
        </c-new-stock>

        <c-change-status
            v-if="item.product"
            v-show="changeStatus"
            @close="changeStatus=false"
            @added="load"
            :size="'small'"
            :item="item">
        </c-change-status>

        <c-update-item
            v-if="item.product"
            v-show="updateItem"
            @close="updateItem=false"
            @added="load"
            :size="'medium'"
            :item="item">
        </c-update-item>

        <c-repair-request v-if="repair"
			v-show="repair"
			:items="itemArray"
            :addresses="addresses()"
			:parent_client_id="item.client ? item.client.parent_client_id : item.product.client.parent_client_id"
			:client_id="item.client ? item.client.id : item.product.client.id"
			@close="repair=false"
            @added="load"
			:size="'medium'"/>

        <c-eol-swap v-if="swap"
			v-show="swap"
			:items="itemArray"
			:addresses="addresses()"
			:parent_client_id="item.client ? item.client.parent_client_id : item.product.client.parent_client_id"
			:client_id="item.client ? item.client.id : item.product.client.id"
			@close="swap=false"
			:size="'medium'"/>

        <c-mutations v-if="item.product"
            title="Mutatie"
            v-show="mutation"
            :item="item"
            @close="mutation=false"
            @reload="load">
        </c-mutations>

    </div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CBreadcrumbs from '@components/Breadcrumbs';
import CBlockItemInfo from '@components/blocks/ItemInfo';
import CBlockImage from '@components/blocks/Image';
import CBlockActivity from '@components/blocks/Activity';
import CBlockActivities from '@components/blocks/Activities';
import CNewStock from '@app/modals/NewStock';
import CChangeStatus from '@app/modals/ChangeStatus';
import CUpdateItem from '@app/modals/UpdateItem';
import CRepairRequest from '@app/modals/RepairRequest';
import CEolSwap from '@app/modals/EolSwap';
import CMutations from '@app/modals/Mutations';

export default {
    mixins: [View, Form],
    components: {
        CBreadcrumbs,
        CBlockItemInfo,
        CBlockImage,
        CBlockActivity,
        CBlockActivities,
        CNewStock,
        CChangeStatus,
        CUpdateItem,
        CRepairRequest,
        CEolSwap,
        CMutations
    },
    data() {
        return {
            item: {},
            modal: false,
            changeStatus: false,
            updateItem: false,
            status: '',
            repair: false,
            swap: false,
            mutation: false,
            itemArray: [],
            activitiesRender: 0,
        }
    },
    methods: {
        load() {
            this.activitiesRender += 1;
            this.$xhr.get('/api/items/' + this.$route.params.id).then(({result}) => {
                this.item = result;
                this.itemArray = [];
                this.itemArray.push(this.item);
                if (result.events.length > 0) {
                    this.status = this.item.status;

                } else {
                    this.status = " ";
                }
            }).catch((e) => {
                this.$store.dispatch('toast/alert', {
                    title: 'Foutmelding',
                    text: 'Artikelgegevens kunnen niet worden ingeladen'
                });
            });
        },
        openModal() {
            this.modal = true;
        },
        modalChangeStatus() {
            this.changeStatus = true;
        },
        modalUpdateItem() {
            this.updateItem = true;
        },
        openRepairModal(){
            this.repair = true;
        },
        openSwapModal(){
            this.swap = true;
        },
        openMutationModal(){
            this.mutation = true;
        },
        addresses() {
			return [ ...this.item.client ? this.item.client.addresses: [], ...this.item.product.client.addresses ?? []];
		},
    },
    created() {
        this.$store.dispatch('listener/on', {
            event: 'new-stock',
            listener: this.openModal
        });
        this.$store.dispatch('listener/on', {
            event: 'repair',
            listener: this.openRepairModal
        });
        this.$store.dispatch('listener/on', {
            event: 'swap',
            listener: this.openSwapModal
        });
        this.$store.dispatch('listener/on', {
            event: 'change-status',
            listener: this.modalChangeStatus
        });
        this.$store.dispatch('listener/on', {
            event: 'update-item',
            listener: this.modalUpdateItem
        });
        this.$store.dispatch('listener/on', {
            event: 'mutation',
            listener: this.openMutationModal
        });
    },
    beforeUnmount() {
        this.$store.dispatch('listener/off', {
            event: 'new-stock',
            listener: this.openModal
        });
        this.$store.dispatch('listener/off', {
            event: 'repair',
            listener: this.openRepairModal
        });
        this.$store.dispatch('listener/off', {
            event: 'swap',
            listener: this.openSwapModal
        });
        this.$store.dispatch('listener/off', {
            event: 'change-status',
            listener: this.modalChangeStatus
        });
        this.$store.dispatch('listener/off', {
            event: 'update-item',
            listener: this.modalUpdateItem
        });
        this.$store.dispatch('listener/off', {
            event: 'mutation',
            listener: this.openMutationModal
        });
    },
    mounted() {
        this.load();
    }
}
</script>
